module.exports = __webpack_public_path__ + "img/home.38669fa6.svg";